const mapLocations = () => {

    const locations = $('.location'), marker = $('.marker');

    if (locations && marker) {
        locations.each((idx, location) => {
            $(location).on('mouseenter', function() {
                let coordinateX = $(this).attr('data-x'),
                    coordinateY = $(this).attr('data-y');

                marker.css({'top' : `${coordinateY}%`,
                            'left' : `${coordinateX}%`,
                            'opacity' : '1'
                });
            })
            $(location).on('mouseleave', function() {
                marker.css('opacity', '0');
            })
        })
    }
}

export default mapLocations;